module.exports = __webpack_public_path__ + "static/media/cogito-metaverse.7c2cfa76.png";